export const HTTP_METHODS = [
  "all",
  "checkout",
  "connect",
  "copy",
  "delete",
  "get",
  "head",
  "lock",
  "merge",
  "mkactivity",
  "mkcol",
  "move",
  "m-search",
  "notify",
  "options",
  "param",
  "patch",
  "post",
  "propfind",
  "propatch",
  "purge",
  "put",
  "report",
  "search",
  "subscribe",
  "trace",
  "unlock",
  "unsuscribe"
];
